import {useState} from 'react';
import {addQueryParamsToUrl} from '../helpers';
import {NotificationList} from '../types/Notifications';
import {useAuthedQuery} from './QueryHooks';

interface Props {
	initialItemPerPage?: number;
}

const useNotifications = ({initialItemPerPage = 10}: Props) => {
	const [currentPage, setCurrentPage] = useState(1);
	const [itemPerPage, setItemPerPage] = useState(initialItemPerPage);

	const url = addQueryParamsToUrl('notifications/enterpriser/all', {
		page: currentPage,
		size: itemPerPage,
	});

	const changeItemPerPage = (page: number) => {
		setCurrentPage(1);
		setItemPerPage(page);
	};

	const {data, isLoading} = useAuthedQuery<NotificationList>(url);
	return {
		data,
		isLoading,
		setCurrentPage,
		changeItemPerPage,
	};
};

export default useNotifications;
